import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import InputError from "../../common/input-error/InputError";
import css from "./_PhoneNumberInput.module.scss";
import { AsYouType, parsePhoneNumber } from "libphonenumber-js";
import suggestions from "../../../static/country-codes.json";

const getCountryCallingCodeInitialState = (value) => {
  if (!value) {
    return {
      name: "France",
      dial_code: "+33",
      code: "FR",
    };
  }

  try {
    const parsed = parsePhoneNumber(value);
    if (parsed) {
      return {
        dial_code: "+" + parsed.countryCallingCode,
        code: parsed.country,
      };
    }
  } catch (e) {
    
  }


  return {
    name: "France",
    dial_code: "+33",
    code: "FR",
  };
};

const PhoneNumberInput = ({
  customClass,
  inputId,
  inputLabel,
  inputName,
  inputPlaceholder,
  errors,
  touched,
  hideErrors,
  value,
  onChange,
  maxLength,
  onBlur,
  makeErrorsVisible,
  disabled,
  autocomplete,
  setFieldValue,
  required,
  ...props
}) => {
  const [isHideSuggs, setIsHideSuggs] = useState(true);
  const [countryCallingCode, setCountryCallingCode] = useState(getCountryCallingCodeInitialState(value));

  const hideSuggs = (item) => {
    value =
      value?.indexOf(countryCallingCode.dial_code) > -1
        ? value.replace(countryCallingCode.dial_code, item.dial_code)
        : `${item.dial_code}${value}`;
    setCountryCallingCode(item);
    setFieldValue(inputName, value);
    setIsHideSuggs(true);
  };

  const suggestionsRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      suggestionsRef.current &&
      !suggestionsRef.current.contains(event.target)
    ) {
      setIsHideSuggs(true);
    }
  };

  const handleSearch = (event) => {
    if (event.key) {
      const indx = suggestions.findIndex((item) => {
        return item.name.toLowerCase().startsWith(event.key.toLowerCase());
      });
      if (indx && indx > -1) {
        suggestionsRef.current.scrollTop = document.getElementById(
          "sug_" + indx + "_" + suggestions[indx].dial_code
        ).offsetTop;
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    window.addEventListener("keydown", handleSearch);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      window.removeEventListener("keydown", handleSearch);
    };
  }, []);

  return (
    <div className={`${css.input__wrapper}  ${customClass || ""}`}>
      <label htmlFor={inputId} className={css.label}>
        {inputLabel} {required && "*"}
      </label>
      <input
        name={inputName}
        id={inputId}
        placeholder={inputPlaceholder}
        className={`${css.input} ${
          !hideErrors &&
          errors[inputName] &&
          touched &&
          touched[inputName] &&
          css.input__error
        } ${disabled ? css.disabled_input : ""}`}
        value={
          value
            ? new AsYouType(countryCallingCode.code).input(
                value.split(countryCallingCode.dial_code)[1] || ''
              )
            : ""
        }
        onChange={(e) => {
          const phoneNumber = e.target.value
            ? `${countryCallingCode.dial_code}${e.target.value.replaceAll(
                /\D/g,
                ""
              )}`
            : e.target.value;
          setFieldValue(inputName, phoneNumber);
        }}
        maxLength={maxLength}
        onBlur={onBlur}
        onFocus={() => makeErrorsVisible && makeErrorsVisible()}
        disabled={disabled}
        autoComplete={autocomplete}
        ref={props.anchorRef}
      />
      <div
        className={css.input__countryCallingCode}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsHideSuggs(false);
        }}
      >
        {countryCallingCode.dial_code}
      </div>
      <div
        ref={suggestionsRef}
        className={css["suggestions"]}
        style={{ display: isHideSuggs ? "none" : "block" }}
      >
        {suggestions.map((item, idx) => (
          <div
            key={"sug_" + item + idx}
            onClick={() => {
              hideSuggs(item);
            }}
            id={"sug_" + idx + "_" + item.dial_code}
          >
            {item.name} ({item.dial_code})
            {countryCallingCode.dial_code === item.dial_code && (
              <img
                src="/static/images/pictos/icon-check-primary.svg"
                width={"16px"}
              />
            )}
          </div>
        ))}
      </div>
      {!hideErrors && <InputError name={inputName} />}
    </div>
  );
};

PhoneNumberInput.propTypes = {
  inputId: PropTypes.string.isRequired,
  inputLabel: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  inputPlaceholder: PropTypes.string,
};

PhoneNumberInput.defaultProps = {
  inputId: "addAnId",
  inputLabel: "Input desc :",
  inputName: "addName",
  inputPlaceholder: "Write Something",
};

export default PhoneNumberInput;
